<template>
	<div class="assest-log-page">

    <div class="search-form flex-center-start">
      <div class="form-item flex-center-start">
        <div class="label">{{ $t('zi-jin-lei-xing') }}</div>
        <div class="input border">
          <a-select v-model="pageType"  dropdownClassName="full-select" class="hide-border" :placeholder="$t('qing-xuan-ze')" @change="changeType">
            <img :src="downUrl" slot="suffixIcon" class="suffix-icon">
            <a-select-option v-for="(option, index) in pageTypeList" :key="index" :value="option.value" >
              {{option.label}}
            </a-select-option>
          </a-select>
        </div>
      </div>

      <div class="form-item flex-center-start">
        <div class="label">{{ $t('chart_page.time') }}</div>
        <div class="input long flex-center">
          <custom-date-picker
            v-model="form.startTime"
            :placeholder="$t('common.startDatePlaceholder')"
            :show-icon="false"
          ></custom-date-picker>
          <span class="space">{{ $t('zhi') }}</span>
          <custom-date-picker
            v-model="form.endTime"
            :placeholder="$t('common.endDatePlaceholder')"
            :show-icon="false"
          ></custom-date-picker>
        </div>
      </div>
    </div>

    <div class="list-table">
      <div class="th-line flex-center-between">
        <div class="th flex-2">{{ $t('followDetail.label15') }}</div>
        <div class="th flex-2">{{ $t('follow.label17') }}</div>
        <div class="th flex-2">{{ $t('jiao-yi-fang-xiang') }}</div>
        <div class="th flex-2">{{ $t('jiao-yi-shi-jian') }}</div>
        <div class="th action long">{{ $t('jiao-yi-hou-jineusdt') }}</div>
      </div>
      <div class="tbody">
        <div class="td-line flex-center-between" v-for="(item, i) in dataList" :key="i" >
          <div class="td flex-2 flex-center-start">
            {{getName()}}
          </div>
          <div class="td flex-2">{{item.Practical}}</div>
          <div class="td flex-2">{{getTypeName(item, item.Currency.ShortName) }}</div>
          <div class="td flex-2">{{item.CreatedAt}}</div>
          <div class="td action long">
            {{item.DebtAfter}}
          </div>
        </div>
      </div>
    </div>

    <pageBar :total="page.total" @changePage="changePage"></pageBar>

	</div>
</template>
<script>
import { debtType, debtLog } from '@/api/assest'
import pageBar from '@/components/pageBar'
import { List } from 'vant'
import CustomDatePicker from '@/components/CustomDatePicker.vue'
export default {
  components: {
    List,
    pageBar,
    CustomDatePicker
  },
  data() {
		return {
      form: {
        bit: '',
        type: '',
        account: '',
        startTime: '',
        endTime: ''
      },
      tabIndex: 1,
      page: {
        page: 1,
        limit: 10,
        total: 1
      },
      isInit: false,
      loading: false,
      finished: false,
      totalPage: 1,
      bitName: this.i18n.t('assestLog.option1'),
      typeName: this.i18n.t('assestLog.option2'),
      accountName: this.i18n.t('assestLog.option11'),
			backUrl: require('../../assets/imgs/icon-back.png'),
      downUrl: require('../../assets/imgs/icon-arrow-down2.png'),
      dataList: [],
      showBitOption: false,
      showTypeOption: false,
      showAccountOption: false,
      typeList: [],
      pageType: '',
      pageTypeList: [
        {
          value: '1',
          label: this.$t('pageTitle.account1')
        },
        {
          value: '2',
          label: this.$t('pageTitle.account2')
        },
        {
          value: '3',
          label: this.$t('pageTitle.account3')
        },
        {
          value: '4',
          label: this.$t('pageTitle.account4')
        },
        {
          value: '5',
          label: this.$t('transfer.account1')
        },
        {
          value: '6',
          label: this.$t('pageTitle.account6')
        },
      ]
		}
	},

  mounted() {
    this.pageType = this.$route.query.type || '1'
    this.pageType += ''
    this.initType()
  },
	methods: {
    initType() {
      debtType().then(res => {
        let data = res.data
        let list = [ ]
        for (let key in data) {
          let param = {
            value: key,
            label: data[key]
          }
          list.push(param)
        }
        this.typeList = list
        this.init()
      })
    },
    changePage(page) {
      this.page.page = page
      this.init()
    },
    init() {
      let form = new FormData()
      let type = ''
      let multiType = ''
      switch (this.pageType + '') {
        case '1': type = 'Option'; multiType = '2,3,9,10,11'; break;
        case '2': type = 'Contract'; multiType = '2,3,12,13,14,15,21,22,23,24,25'; break;
        case '3': type = 'Spot'; multiType = '2,3,6,7,8'; break;
        case '4': type = 'Finance'; multiType = '2,3,5,16,33'; break;
        case '5': type = 'Capital'; multiType = '4,31,32,2,3'; break;
        case '6': type = 'Follow'; multiType = '2,3,9,10,1112,13,14,15,21,22,23,24,25'; break; // 跟单
        default: break;
      }
      form.append('current', this.page.page)
      form.append('limit', this.page.limit)
      form.append('CurrencyType', type)
      form.append('Type', '')
      form.append('MultiType', multiType)
      form.append('CurrencyId', this.form.bit)
      debtLog(form).then(res => {
        let list = res.data.Items.filter(v => {
          return v.Type != 1
        })
        if (res.data.Items) {
          this.dataList = list
          this.page.total = res.data.Pagination.totalRecords
        }
      })
    },
    changeTab(i) {
      this.tabIndex = i
      this.page.page = 1
      this.form.type = i == 1 ? 4 : 17
      this.init()
    },
    back() {
      this.$router.go(-1)
    },
    getTypeName(item, name) {
      let type = item.Type
      let index = this.typeList.findIndex(v => {
        return v.value == type
      })
      if (index > -1) {
        if (type == 9) {
          return this.i18n.t('assestLog.order') + "(" + name + ")"
        } else if (type == 6) {
          return this.i18n.t('assestLog.order') + "(" + item.Digest + ")"
        } else if (type == 7) {
          return this.i18n.t('assestLog.Sell') + "(" + item.Digest + ")"
        } else if (type == 11) {
          return this.i18n.t('assestLog.Settle') + "(" + name + ")"
        } else {
          return this.typeList[index].label+ "(" + name + ")"
        }
      } else {
        return name
      }
    },
    getName() {
      let index = this.pageTypeList.findIndex(v => {
        return v.value == this.pageType
      })
      if (index > -1) {
        return this.pageTypeList[index].label
      } else {
        return ''
      }
    },
    changeType() {
      this.page.page = 1
      this.init()
    }
	}
}
</script>